
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './router';
import './index.css';
import 'swiper/css';
import '@nutui/nutui-react/dist/style.css';
import { ConfigProvider } from "@nutui/nutui-react";
import { fetchLanguage } from './i18n/index';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

fetchLanguage('en').then(() => {
  root.render(
    <ConfigProvider theme={{
      nutuiBrandColor: 'rgb(245, 119, 102)',
      nutuiBrandColorStart: 'rgb(245, 119, 102)',
      nutuiBrandColorEnd: 'rgb(245, 119, 102)',
    }}>
      <App />
    </ConfigProvider>
  );
});


